import Vue from "vue"
import Router from 'vue-router'
import {page} from "../fui"

Vue.use(Router)
//const test = () => import('../components/test.vue')

const test = {
  template: '<div>foo<input type="text" /></div>'
}

//$.fuiBaseUrl = "/pa/"
Vue.prototype.$baseUrl = "/"
//Vue.prototype.$baseUrl = "/pa/"
Vue.prototype.$apiUrl = "/api/"

const baseUrl = Vue.prototype.$baseUrl
//console.log("111111111111", baseUrl)
const routes = [
  {
    path: baseUrl + 'login',
    component: () =>  import ("../Login") 
  },
  {
    path: baseUrl + 'mobileLogin',
    component: () => import ("../mobile/login"),
  },
  {
    path: baseUrl + 'mobileHome',
    component: () => import ("../mobile/home"),
  },

  {
    path: baseUrl + 'orderDinner',
    component: () => import ("../mobile/orderDinner"),
  },
  {
    path: baseUrl + 'wap',
    component: () => import ("../wap/home"),
  },
  {
      path: baseUrl + "declare",
      component: () => import ("../wap/declare")
  },
  {
      path: baseUrl + "dc",
      component: () => import ("../wap/empHome")
  },
  {
      path: baseUrl + "todayDeclare",
      component: () => import ("../wap/todayDeclare")
  },
  {
      path: baseUrl + "runningAccounts",
      component: () => import ("../wap/runningAccounts")
  },
  {
      path: baseUrl + "balance",
      component: () => import ("../wap/balance")
  },
  {
      path: baseUrl + "empConsumption",
      component: () => import ("../wap/empConsumption")
  },
  {
      path: baseUrl + "consumption",
      component: () => import ("../wap/consumption")
  },
  {
    path: baseUrl + 'home',
    redirect: baseUrl
  },
  {
    path: baseUrl,
    component: () => import ("../Home"),
    name: 'ERP',
    children: [{
        path: "attendance",
        component: () =>
          import ("../page/attendance/")
      },
      {
        path: "dept",
        component: () =>
          import ("../page/dept/")
      },
      {
        path: "summarydept",
        component: () =>
          import ("../page/summarydept/")
      },
      {
        path: "employee",
        component: () =>
          import ("../page/employee/")
      },
      {
        path: "hrChange",
        component: () =>
          import ("../page/hrChange/")
      },
      {
        path: "card",
        component: () =>
          import ("../page/card/")
      },
      {
        path: "shift",
        component: () =>
          import ("../page/shift/")
      },
      {
        path: "shiftGroup",
        component: () =>
          import ("../page/shiftGroup/")
      },
      {
        path: "originalRecord",
        component: () =>
          import ("../page/originalRecord/")
      },
      {
        path: "summary",
        component: () =>
          import ("../page/summary/")
      },
      {
        path: "summaryB",
        component: () =>
          import ("../page/summaryB/")
      },
      {
        path: "leave",
        component: () =>
          import ("../page/leave/")
      },
      {
        path: "user",
        component: () =>
          import ("../page/user/")
      },
      {
        path: "role",
        component: page.role
      },
      {
        path: "rights",
        component: page.rights
      },
      {
        path: "loginLog",
        component: page.loginLog
      },
      {
        path: "action",
        component: page.actionLog
      },
      {
        path: "exception",
        component: page.exceptionLog
      },
      {
        path: "sysCode",
        component: page.sysCode
      },
      {
        path: "calendar",
        component: () =>
          import ("../page/calendar/")
      },
      {
        path: "device",
        component: () =>
          import ("../page/device/")
      },
      {
        path: "task",
        component: () =>
          import ("../page/task/")
      },
      {
        path: "cycle",
        component: () =>
          import ("../page/cycle/")
      },
      {
        path: "jobSalary",
        component: () =>
          import ("../page/salaryJob/")
      },
      {
        path: "empSalary",
        component: () =>
          import ("../page/salaryEmp/")
      },
      {
        path: "salaryReportDefine",
        component: () =>
          import ("../page/salaryDefine/")
      },
      {
        path: "salaryBonus",
        component: () =>
          import ("../page/salaryBonus/")
      },
      {
        path: "salary",
        component: () =>
          import ("../page/salary/")
      },
      {
        path: "salaryMethod",
        component: () =>
          import ("../page/salaryMethod/")
      },
      {
        path: "salaryFormula",
        component: () =>
          import ("../page/salaryFormula/")
      },
      {
        path: "socialSecurity",
        component: () =>
          import ("../page/socialSecurity/")
      },
      {
        path:"salaryImport",
        component:()=>
          import("../page/salaryImport")
      },
      {
        path: "plan",
        component: () =>
          import ("../page/plan/")
      },
      {
        path: "accessControl",
        component: () =>
          import ("../page/accessControl/")
      },
      {
        path: "order",
        component: () =>
          import ("../page/order/")
      },
      {
        path: "dinnerSetting",
        component: () =>
          import ("../page/dinnerSetting/")
      },
      {
        path: "dinnerRecord",
        component: () =>
          import ("../page/dinnerRecord/")
      },
      {
        path: "dinnerDeclare",
        component: () =>
          import ("../page/dinnerDeclare/")
      },
      {
        path: "dinnerOrder",
        component: () =>
          import ("../page/dinnerOrder/")
      },
      {
        path: "company",
        component: () =>
          import ("../page/company/")
      },
      {
        path: "shiftEmp",
        component: () =>
          import ("../page/employeeShift/")
      },
      {
        path: "shiftEmpB",
        component: () =>
          import ("../page/employeeShiftB/")
      },
      {
        path: "roster",
        component: () =>
          import ("../page/roster/")
      },
      {
        path: "attendanceRate",
        component: () =>
          import ("../page/attendanceRate/")
      },
      {
        path: "empHealth",
        component: () =>
          import ("../page/empHealth/")
      },
      {
        path: "deptConf",
        component: () =>
          import ("../page/deptConf/")
      },
      {
        path: "daily",
        component: () =>
          import ("../page/dailyReport/")
      },
      {
        path: "recharge",
        component: () =>
          import ("../page/recharge/")
      },
      {
        path: "rechargeRecord",
        component: () =>
          import ("../page/rechargeRecord/")
      },
      {
        path: "empAccount",
        component: () =>
          import ("../page/empAccount/")
      },
      {
          path: "runningAccount",
          component: () => import ("../page/runningAccount")
      },
      {
          path: "weChatBinding",
          component: () => import ("../page/weChatBinding")
      },
      {
          path: "weChatUser",
          component: () => import ("../page/weChatUser")
      },
      {
        path: "repair",
        component: () =>
          import ("../page/repair/")
      },
      {
        path: "weixin",
        component: () =>
          import ("../page/weixin/")
      },
      {
        path: "absentDay",
        component: () =>
          import ("../page/absentDay/")
      },
      {
        path: "buka",
        component: () =>
          import ("../page/buka/")
      },
      {
        path: "chuchai",
        component: () =>
          import ("../page/chuchai/")
      },
      {
        path: "welcome",
        component: () =>
          import ("../page/welcome/")
      }
    ]
  }

]

export default new Router({
  routes,
  mode: "history"
})
